import { axiosInstance } from "./AxiosInstance";
import Urls from "../Urls";
class BookingReq {
  GetLesson = (id) => {
    return axiosInstance({
      url: Urls.teacherLessons(id),
      method: "GET",
    });
  };
  getAvailability = (id, params) => {
    return axiosInstance({
      url: Urls.teacherAvailability(id),
      method: "get",
      params,
    });
  };
  BookLesson = (data) => {
    return axiosInstance({
      url: Urls.BookLesson(),
      method: "post",
      data,
    });
  };
  BookLessonByID = (id) => {
    return axiosInstance({
      url: Urls.BookLessonByID(id),
      method: "get",
    });
  };
  Payment = (id) => {
    return axiosInstance({
      url: Urls.Payment(id),
      method: "get",
    });
  };
  WalletBalance = () => {
    return axiosInstance({
      url: Urls.Wallet(),
      method: "get",
    });
  };
  CheckoutVoucher = (data) => {
    return axiosInstance({
      url: Urls.CheckoutVoucher(),
      method: "post",
      data,
    });
  };
}
export default new BookingReq();
